import * as React from "react";
import { Input } from "./input";
import { cleanAmount } from "../../lib/amount";

const inrGroup = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 2 });

function formatIndianGroups(raw) {
    if (raw === null || raw === undefined) return "";
    const s = String(raw);
    if (s === "" || s === "-" || s === ".") return s;
    const neg = s.startsWith("-");
    const body = neg ? s.slice(1) : s;
    const [intPart, decPart] = body.split(".");
    if (intPart === "") return (neg ? "-" : "") + (decPart !== undefined ? "." + decPart : "");
    const n = parseInt(intPart, 10);
    if (Number.isNaN(n)) return s;
    const grouped = inrGroup.format(n);
    const out = decPart !== undefined ? `${grouped}.${decPart}` : grouped;
    return (neg ? "-" : "") + out;
}

/**
 * Controlled amount input that:
 *  - Renders the value with Indian numbering grouping (1,00,000) while typing
 *  - Internally stores / emits the raw numeric string so calculations are unaffected
 *  - Never shows a leading "0" (so "010000" can't happen)
 *  - Allows empty / in-progress typing (trailing dot, "-", etc.)
 *
 * Usage:
 *   <AmountInput value={amount} onChange={setAmount} />
 *   // at submit time: Number(amount)
 */
const AmountInput = React.forwardRef(function AmountInput(
    { value, onChange, ...rest },
    ref,
) {
    const raw =
        value === 0 || value === "0" ? "" :
        value === null || value === undefined ? "" : String(value);
    const displayed = formatIndianGroups(raw);

    return (
        <Input
            ref={ref}
            inputMode="decimal"
            type="text"
            value={displayed}
            onChange={(e) => onChange(cleanAmount(e.target.value))}
            {...rest}
        />
    );
});

export { AmountInput };
export default AmountInput;
